import { type ExtractPropTypes, computed, type PropType } from 'vue';

import { type RadiusType, radiusList } from '../../typings/radiusType';

export const withRadiusProps = {
  /**
   * Zaokrąglenie elementu
   */
  radius: {
    type: String as PropType<RadiusType>
  }
};

/**
 * Zwraca klasę zaokrąglenia
 *
 * @export
 * @param {string} prefix
 * @param {ExtractPropTypes<typeof withRadiusProps>} props
 * @return {*}  {Record<string, boolean>}
 */
export const useRadiusProps = (prefix: string, props: ExtractPropTypes<typeof withRadiusProps>) => {
  return computed(() => ({
    [`${prefix}--${props.radius}`]: props.radius !== undefined
  }));
};

/**
 * Konfiguracja dla storybooka
 */
export const storiesRadiusArgs = {
  args: {
    radius: undefined
  },

  argTypes: {
    radius: {
      options: radiusList,
      control: { type: 'inline-radio' }
    }
  }
};
